import { render, staticRenderFns } from "./data-backup.vue?vue&type=template&id=18b20de0&scoped=true&"
import script from "./data-backup.vue?vue&type=script&lang=js&"
export * from "./data-backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b20de0",
  null
  
)

export default component.exports